import {create} from 'zustand'

export interface Estimate {
  id: number,
  content1: string|null,
  content2: string|null,
  content3: string|null,
  title: string|null,
  userID: number,
  description: string,
  hospitalID: number|null,
  location: [number, number],
  proposalList: any|null,
  tagList: string[],
  status: string,
  userInfo: any,
  createdAt: string,
  reservedAt: string|null
}


interface EstimateState {
  curEsti: Estimate|null,
  setEstimate: (estimate:Estimate|null) => void
  estimateList: Estimate[]
  setEstimateList: (list:Estimate[]) => void,
  curHistory: Estimate|null,
  setHistory: (history:Estimate|null) => void
}

const useEstimateStore = create<EstimateState>((set) => ({
  curEsti: null,
  setEstimate: (estimate:Estimate|null) => set({ curEsti: estimate }),
  estimateList: [],
  setEstimateList: (list:Estimate[]) => set({ estimateList: list }),
  curHistory: null,
  setHistory: (history:Estimate|null) => set({ curHistory: history })
}))

export default useEstimateStore